export default "__VITE_ASSET__CZLC9tui__"